import useTranslator from '@/hooks/translation'
import { Company } from '@/services/fintalk/services/fintalk-backoffice/companies/list'

import { Button } from '../ui/button'
import { CompanyDisplay } from './company-display'

interface CompanyListProps {
  companies: Company[]
  onSelect: (company: Company) => void
}

export function CompanyList({ companies, onSelect }: CompanyListProps) {
  const { getTranslation } = useTranslator()

  if (companies.length === 0) {
    return (
      <div className="flex justify-center p-4 text-sm text-muted-foreground">
        {getTranslation('common.noResults')}
      </div>
    )
  }

  return (
    <div className="max-h-[320px] overflow-y-auto p-3">
      <ul className="flex flex-col gap-1">
        {companies.map((company) => (
          <li key={company._id}>
            <Button
              variant="ghost"
              className="w-full justify-start"
              onClick={() => onSelect(company)}
            >
              <CompanyDisplay company={company} />
            </Button>
          </li>
        ))}
      </ul>
    </div>
  )
}
